import type { MediaKind } from '@prisma/client'

import { Image, type ImageProps } from './Image'
import { Video, type VideoProps } from './Video'

export type MediaProps =
  | ({
      kind: MediaKind
    } & ImageProps)
  | ({
      kind: MediaKind
    } & VideoProps)

const isImageProps = (
  props: MediaProps
): props is ImageProps & { kind: MediaKind } => props.kind === 'image'

const isVideoProps = (
  props: MediaProps
): props is VideoProps & { kind: MediaKind } => props.kind === 'video'

export const Media = ({
  ref,
  ...props
}: MediaProps & { ref?: React.Ref<HTMLImageElement | HTMLVideoElement> }) => {
  if (isImageProps(props)) {
    const { kind, ...rest } = props
    return <Image {...rest} ref={ref as React.Ref<HTMLImageElement>} />
  }

  if (isVideoProps(props)) {
    const { kind, ...rest } = props
    return <Video {...rest} ref={ref as React.Ref<HTMLVideoElement>} />
  }

  console.warn(
    'Media component received unsupported props. Expected kind to be "image" or "video".'
  )

  return null
}
